import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { ROLES } from "../constants/roles.constants";

export const AdminPermissionGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    // Zablokowanie dostępu użytkownikom 
    if(authService.user === null || authService.user.role!.role_id === 0) {
        // console.log('brak dostępu dla: ', authService.user)
        return false;
    } else {
        // console.log('ma dostęp: ', authService.user,"Z wartością: ", authService.user.is_admin === 1 || authService.user.is_admin === 100)
        return authService.user.role!.role_id >= ROLES.admin ;
    }
};